import { render, staticRenderFns } from "./UserManagerPoints.vue?vue&type=template&id=054102c6&scoped=true&"
import script from "./UserManagerPoints.vue?vue&type=script&lang=js&"
export * from "./UserManagerPoints.vue?vue&type=script&lang=js&"
import style0 from "./UserManagerPoints.vue?vue&type=style&index=0&id=054102c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054102c6",
  null
  
)

export default component.exports